const DailyIncomeSummery = () => {
    return (
        <div>
            DailyIncomeSummery
        </div>
    );
}
export default DailyIncomeSummery;